var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{attrs:{"shadow":"","danger":""},on:{"click":function($event){return _vm.refresh()}}},[_vm._v("\n        Volver a finanzas\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }